import { css, Theme } from '@emotion/react'

export const globalStyles = (theme: Theme) => css`
  /* All headers + descendants */
  h1,
  h1 *,
  h2,
  h2 *,
  h3,
  h3 *,
  h4,
  h4 *,
  h5,
  h5 *,
  h6,
  h6 * {
    font-family: ${theme.fonts.heading.family};
    font-weight: ${theme.fonts.heading.weight};
  }

  /* Everything else */
  body {
    font-family: ${theme.fonts.body.family};
    font-weight: ${theme.fonts.body.weight}; /* e.g. 400 */
  }

  button {
    font-family: ${theme.fonts.body.family};
    font-weight: 600;
  }

  input,
  textarea {
    font-family: ${theme.fonts.body.family};
    font-weight: ${theme.fonts.body.weight}; /* e.g. 400 */
  }
`
